import { styled } from '@mui/system'
import Badge from '@mui/material/Badge'

const SidebarNotificationBadge = styled(Badge)(({ theme }) => ({
	'& >span': {
		fontSize: '1rem',
		padding: '0.1875rem 0.5rem',
		borderRadius: '1.25rem',
		height: '1.85rem',
		border: `0.1875rem solid ${theme.palette.text.primary}`,
		minWidth: '1.85rem',
		display: 'inline-block',
		lineHeight: 1.1,
	},
}))

export { SidebarNotificationBadge }
